import * as React from 'react';
import { themePalette } from '../../../utils/theme-palette';

const AssessmentsIcon = ({ size = 24, active = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        id="Vector"
        d="M8 7V1"
        stroke={active ? themePalette.blue : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        id="Vector_2"
        d="M14 7V1"
        stroke={active ? themePalette.blue : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M20 7V1"
        stroke={active ? themePalette.blue : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M25 4H3C1.89543 4 1 4.89543 1 6V25C1 26.1046 1.89543 27 3 27H25C26.1046 27 27 26.1046 27 25V6C27 4.89543 26.1046 4 25 4Z"
        fill={active ? themePalette.blue : 'none'}
        stroke={active ? themePalette.blue : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M7 14H21"
        stroke={active ? 'white' : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M7 20H15"
        stroke={active ? 'white' : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_7"
        d="M8 7V4"
        stroke={active ? 'white' : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_8"
        d="M14 7V4"
        stroke={active ? 'white' : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_9"
        d="M20 7V4"
        stroke={active ? 'white' : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default AssessmentsIcon;
